import type { ApiSurface } from '../auth/login.js';

/** One namespace per API surface — 10-11 § Namespaces */
export const REALTIME_NAMESPACES: Record<ApiSurface, string> = {
  customer: '/customer',
  merchant: '/merchant',
  admin: '/admin',
  business: '/business',
};

/** Documented room patterns — 10-11 § Room naming convention */
export const REALTIME_ROOM_PATTERNS = [
  'order:{orderId}',
  'branch:{branchId}:orders',
  'business:{businessId}:ops',
  'customer:{customerId}',
  'customer:{customerId}:approvals',
  'admin:platform',
  'admin:incident:{id}',
  'business:account:{accountId}',
  'business:approval:{approvalId}',
  'branch:{branchId}:catalogue',
  'case:{caseId}',
] as const;

export const REALTIME_MAX_ROOMS_PER_CONNECTION = 20;

export function resolveRealtimeNamespace(surface: ApiSurface): string {
  return REALTIME_NAMESPACES[surface];
}

export function orderRoom(orderId: string): string {
  return `order:${orderId}`;
}

export function branchOrdersRoom(branchId: string): string {
  return `branch:${branchId}:orders`;
}

/** Customer-safe catalogue room on /customer — not merchant `branch:{id}:orders`. */
export function branchCatalogueRoom(branchId: string): string {
  return `branch:${branchId}:catalogue`;
}

export function caseRoom(caseId: string): string {
  return `case:${caseId}`;
}

export function customerRoom(customerId: string): string {
  return `customer:${customerId}`;
}

/** Requester fan-in room on /customer — 10-11. Not business:approval:{id}. */
export function customerApprovalsRoom(customerId: string): string {
  return `customer:${customerId}:approvals`;
}

export function businessOpsRoom(businessId: string): string {
  return `business:${businessId}:ops`;
}

export function businessAccountRoom(accountId: string): string {
  return `business:account:${accountId}`;
}

export function businessApprovalRoom(approvalId: string): string {
  return `business:approval:${approvalId}`;
}

export function adminPlatformRoom(): string {
  return 'admin:platform';
}

export function adminIncidentRoom(incidentId: string): string {
  return `admin:incident:${incidentId}`;
}

/** Compose REST `realtimeChannel` into namespace + room — 10-11 */
export function parseRealtimeChannel(channel: { namespace: string; room: string }): {
  namespace: string;
  room: string;
} {
  return { namespace: channel.namespace, room: channel.room };
}
